import React, { useRef, useEffect, useMemo } from 'react'
import cn from 'classnames'
import Rellax from 'rellax'
import { SimpleImg } from 'react-simple-img'
import styles from './layout.module.css'

const arrCombined = JSON.parse(process.env.REACT_APP_COVERS_ARRAY)

function CoversWall({ wrapperClassName, gridClassName, animationDuration }) {
  const bgRef = useRef(null)
  useEffect(() => {
    let rellax = new Rellax(bgRef.current, {
      speed: -5,
    })
    return () => rellax.destroy()
  }, [])
  return (
    <div className={cn(styles.parallaxWrapper, wrapperClassName)}>
      <div className={cn(styles.imageGrid, gridClassName)} ref={bgRef}>
        {arrCombined.map(([a, b]) => {
          return (
            <ImgComp
              a={a}
              b={b}
              key={`cover_${a}`}
              animationDuration={animationDuration}
            />
          )
        })}
      </div>
    </div>
  )
}

export default CoversWall

const imgStyleBase = {
  position: 'absolute',
  width: '100%',
  height: '100%',
}

const imgStyleVisible = {
  ...imgStyleBase,
  visibility: 'visible',
}

function ImgComp({ a, b, animationDuration = 3 }) {
  const memoizedImgStyle = useMemo(() => {
    return {
      '--delay': a % 10 === 0 ? '0s' : `${a / 2}s`,
      opacity: 0,
      animationName: 'fadeOutIn',
      animationDuration: '24s',
      animationIterationCount: 'infinite',
      animationDelay: 'var(--delay)',
    }
  }, [a])

  return (
    <div className={styles.imageGridItem}>
      <SimpleImg
        src={require(`../images/covers/cover_${a}.jpg`)}
        className={styles.imageGridImage}
        style={imgStyleVisible}
        placeholder={require(`../images/placeholders/cover_${a}.svg`)}
        animationDuration={animationDuration}
      />
      <SimpleImg
        src={require(`../images/covers/cover_${b}.jpg`)}
        style={imgStyleBase}
        placeholder={require(`../images/placeholders/cover_${b}.svg`)}
        imgStyle={memoizedImgStyle}
      />
    </div>
  )
}
